import {
  ActivityIndicator,
  Alert,
  FlatList,
  Image,
  Linking,
  Text,
  TextInput,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppColors } from "../../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import { toast } from "react-toastify";
import { CommonButton } from "../../../../common/CommonButton";
import * as Clipboard from "expo-clipboard";

import InviteSocialMediaModal from "../../Event/InviteSocialMediaModal";
import GoLiveChatModal from "./GoLiveChatModal";
import { AppScreens } from "../../../Utility/AppScreens";
import { MobileDeviceNavigationHeader } from "../Common/MobileDeviceNavigationHeader";
import GoLiveHeader from "../../../../Components/go-live-common-components/GoLiveHeader";
import LiveDetail from "../../../../Components/go-live-common-components/LiveDetail";
import ChatComponent from "../../../../Components/go-live-common-components/ChatComponent";
import GoLiveScene from "../../../../Components/go-live-common-components/GoLiveScene";
import GoLiveGeneralFeat from "../../../../Components/go-live-common-components/GoLiveGeneralFeat";
import GoLiveView from "../../../../Components/go-live-common-components/GoLiveView";
import { getLoginData } from "../../../../utility/AppStoreData";

import { useLiveStream } from "../../../../context/LiveStreamContext";
import moment from "moment";
import LiveStream from "../../../../Components/live-streaming-common-components/LiveStream";
import { fetchEventDetails } from "../../../../services/eventsAPI";
import { fetchStreamDetailsYoutube } from "../../../../services/stream";
import StreamButtons from "./StreamButtons";
import { TouchableWithoutFeedback } from "react-native";
import { developUrl } from "../../../../utility/Index";
import GoLiveOverviewSkeleton from "../../../../Components/skeleton-components/GoLiveOverviewSkeleton";
import GoLiveUpperDropdown from "../../../../Components/skeleton-components/GoLiveUpperDropdown";
import GoliveDisplaySkeleton from "../../../../Components/skeleton-components/GoliveDisplaySkeleton";
import GoLiveHeaderSkeleton from "../../../../Components/skeleton-components/GoLiveHeaderSkeleton";
import Skeletons from "../../../../Components/skeleton-components/Skeletons";
import { ScreenBGGradientView } from "../../../../common/CommonView";
import Header from "../Common/Header";

export default function GoLive({ route }) {
  const { eventId } = route.params;
  const {
    connectToEvent,
    organizerData,
    sendComment,
    loginData,
    organiserLiveStart,
    challengerLiveStart,
    organiserStreamCompleted,
    challengerStreamCompleted,
    setOrganiserStreamStatus,
    setChallengerStreamStatus,
    setOrganiserLiveStart,
    setChallengerLiveStart,
    setOrganiserStreamCompleted,
    setChallengerStreamCompleted,
    loader,
    setLoader,
  } = useLiveStream();

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [selectedButton, setSelectedButton] = useState("Players");
  const [newMessage, setNewMessage] = useState("");
  const flatListRef = useRef(null);
  const [openChat, setOpenChat] = useState(false);
  const [chatOpen, setChatOpen] = useState(true);
  const [accessToken, setAccessToken] = useState(null);
  const [userData, setUserData] = useState(null);
  const [goLiveTooltip, setGoLiveTooltip] = React.useState(false);
  const [pauseToolTip, setPauseToolTip] = useState(false);
  const [chatData, setChatData] = useState(organizerData?.chats || []);
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const initializeLiveStream = async () => {
      const loginData = await getLoginData();
      if (loginData) {
        setUserData(loginData);
        setAccessToken(loginData.AccessToken);
        setLoader(true);
        try {
          const response = await fetchEventDetails(
            eventId,
            loginData.AccessToken,
            "true"
          );
          const { userRole, organiserStreamStatus, challengerStreamStatus } =
            response;

          setUserRole(userRole);

          if (userRole === "audience") {
            navigateToScreen(navigation, AppScreens.GameShowScreen, {
                eventID: eventId,
              });
          } else {
            if (userRole === "organiser") {
              setOrganiserStreamStatus(organiserStreamStatus);
              setOrganiserLiveStart(organiserStreamStatus === "live");
              setOrganiserStreamCompleted(organiserStreamStatus === "complete");
            } else if (userRole === "challenger") {
              setChallengerStreamStatus(challengerStreamStatus);
              setChallengerLiveStart(challengerStreamStatus === "live");
              setChallengerStreamCompleted(
                challengerStreamStatus === "complete"
              );
            }

            connectToEvent(
              loginData.username,
              eventId,
              loginData.AccessToken,
              userRole
            );
          }
        } catch (error) {
          console.error("Error fetching event details:", error);
        }
      }
    };
    initializeLiveStream();
  }, [eventId]);

  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const startDateTime = new Date(organizerData?.eventDetails?.startDateTime);
  const eventStartTime = new Date(organizerData?.eventDetails?.eventStartTime);
  const eventEndTime = new Date(organizerData?.eventDetails?.eventEndTime);

  const calculateTimeDifference = () => {
    const now = new Date();
    if (isNaN(eventStartTime.getTime()) || isNaN(eventEndTime.getTime())) {
      console.error(
        "Invalid event start or end time",
        eventStartTime,
        eventEndTime
      );
      return;
    }

    if (organiserLiveStart || challengerLiveStart) {
      const difference = now.getTime() - eventStartTime.getTime();
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      setTimer({ days, hours, minutes, seconds });
    } else if (organiserStreamCompleted || challengerStreamCompleted) {
      const difference = eventEndTime.getTime() - eventStartTime.getTime();
      if (difference <= 0) {
        setTimer({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        setTimer({ days, hours, minutes, seconds });
      }
    } else {
      const difference = startDateTime.getTime() - now.getTime();
      if (difference <= 0) {
        setTimer({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        setTimer({ days, hours, minutes, seconds });
      }
    }
  };

  useEffect(() => {
    if (organiserStreamCompleted || challengerStreamCompleted) return;

    const interval = setInterval(() => {
      calculateTimeDifference();
    }, 1000);

    return () => clearInterval(interval);
  }, [organizerData, organiserStreamCompleted, challengerStreamCompleted]);

  const addNewMessage = (newMessage) => {
    setChatData((prevChatData) => {
      const updatedChatData = [...prevChatData, newMessage].sort(
        (a, b) => a.timestamp - b.timestamp
      );
      return updatedChatData;
    });
  };

  useEffect(() => {
    setChatData((prevChatData) => {
      const newChats = organizerData.chats.filter(
        (chat) =>
          !prevChatData.find(
            (existing) => existing.commentId === chat.commentId
          )
      );

      const updatedChatData = [...prevChatData, ...newChats].sort(
        (a, b) => a.timestamp - b.timestamp
      );

      return updatedChatData;
    });
  }, [organizerData.chats, organizerData.streamDetails]);

  const filteredChatData =
    chatData
      .filter((chat) => chat.commentType === selectedButton)
      .sort((a, b) => a.timestamp - b.timestamp) || [];

  const socialMediaOptions = [
    { id: 1, name: "Instagram", image: AppImages.icSocialInsta },
    { id: 2, name: "Whatsapp", image: AppImages.icSocialWhatsapp },
    { id: 3, name: "Twitter", image: AppImages.icSocialTwitter },
    { id: 4, name: "Facebook", image: AppImages.icSocialFacebook },
  ];

  const TenMinuteCheck = true;

  const getShareUrl = () => {
    return `${developUrl}/GoLive?eventId=${eventId}`;
  };

  const shareOnPlatform = (platform) => {
    // const url = getShareUrl();
    const url = "";

    let shareUrl = "";

    switch (platform) {
      case "Whatsapp":
        shareUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;
        break;
      case "Instagram":
        shareUrl = `instagram://sharesheet?text=${encodeURIComponent(url)}`;
        break;
      case "Twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          url
        )}`;
        break;
      case "Facebook":
        const message = `Check out this link: ${encodeURIComponent(url)}`;
        shareUrl = `https://www.messenger.com/t/?message=${encodeURIComponent(
          message
        )}`;
        break;
      default:
        break;
    }
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }
  };

  const copyToClipboard = async () => {
    try {
      const linkToCopy = getShareUrl();
      await Clipboard.setStringAsync(linkToCopy);
      toast.success("Link copied to clipboard");
    } catch (error) {
      console.error("Error copying to clipboard:", error);
    }
  };
  const handleOutsideClick = () => {
    if (goLiveTooltip) {
      setGoLiveTooltip(false);
    }
    if (pauseToolTip) {
      setPauseToolTip(false);
    }
  };

  const renderChatMessages = ({ item }) => {
    const isSender = item.userId === loginData.username;

    return (
      <View
        style={{
          marginVertical: 10,
          alignSelf: isSender ? "flex-end" : "flex-start",
        }}
      >
        <View
          style={{
            backgroundColor: isSender
              ? AppColors.purpleColor_9D2CF5
              : AppColors.gray_333333,
            paddingHorizontal: 12,
            paddingVertical: 10,
            borderRadius: 10,
            maxWidth: 200,
            alignSelf: isSender ? "flex-end" : "flex-start",
          }}
        >
          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
            {item.commentData}
          </Text>
        </View>
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_10,
            {
              marginTop: 5,
              alignSelf: isSender ? "flex-end" : "flex-start",
              opacity: 0.6,
            },
          ]}
        >
          {moment(item.timestamp).format("hh:mm A")}
        </Text>
      </View>
    );
  };

  return (
    <TouchableWithoutFeedback onPress={handleOutsideClick}>
      <View
        style={{
          flex: 1,
        }}
      >
        <ScreenBGGradientView />
        {/* {deviceSize === DEVICE_SIZES.XS ? (
          <MobileDeviceNavigationHeader
            btnNotificationTapped={() => {
              navigateToScreen(navigation, AppScreens.NotificationScreen
                  // { txtSearch: searchEvent });
            }}
            btnSettingTapped={() => {
              navigateToScreen(navigation, AppScreens.SettingWebScreen
                  // { txtSearch: searchEvent });
            }}
            btnSearchTapped={() => {
              navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                  // { txtSearch: searchEvent });
            }}
          />
        ) : null} */}
        <Header
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
          btnWalletTapped={() => {}}
          btnStartTutorialTapped={() => {}}
          btnMessageTapped={() => {}}
          btnNotificationTapped={() => {}}
          btnProfileTapped={() => {}}
        />
        <ScrollView
          style={styles.container}
          showsHorizontalScrollIndicator={false}
        >
          {/* innerView */}
          {deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.SM ? null : (
            <>
              {loader ? (
                <GoLiveHeaderSkeleton />
              ) : (
                <GoLiveHeader styles={styles} />
              )}
              <View
                style={{
                  height: 1,
                  backgroundColor: AppColors.white,
                  marginHorizontal: 15,
                }}
              />
            </>
          )}
          <View style={[styles.containerDirection, {}]}>
            {/* Overview */}
            {deviceSize == DEVICE_SIZES.XS ||
            deviceSize == DEVICE_SIZES.SM ||
            deviceSize == DEVICE_SIZES.MD ? null : loader ? (
              <GoLiveOverviewSkeleton styles={styles} />
            ) : (
              <View style={styles.OverView}>
                <View
                  style={{
                    flexDirection: "row",
                    columnGap: 10,
                  }}
                >
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_16]}>
                    Overview
                  </Text>
                  <TouchableOpacity
                    style={{
                      backgroundColor: AppColors.white,
                      height: 18,
                      width: 18,
                      borderRadius: 100,
                    }}
                  >
                    <Image
                      source={AppImages.icArrowRight}
                      style={{
                        height: 16,
                        width: 12,
                        alignSelf: "center",
                        tintColor: AppColors.black,
                      }}
                      resizeMode="contain"
                    />
                  </TouchableOpacity>
                </View>

                <ChatComponent
                  styles={styles}
                  chatOpen={chatOpen}
                  setChatOpen={setChatOpen}
                  chatData={filteredChatData}
                  selectedButton={selectedButton}
                  setSelectedButton={setSelectedButton}
                  renderChatMessages={renderChatMessages}
                  flatListRef={flatListRef}
                  newMessage={newMessage}
                  setNewMessage={setNewMessage}
                  sendComment={sendComment}
                  addNewMessage={addNewMessage}
                  userData={userData}
                  eventId={eventId ?? ""}
                />
              </View>
            )}
            {chatOpen ? (
              <View
                style={{
                  width:
                    deviceSize == DEVICE_SIZES.XS ||
                    deviceSize == DEVICE_SIZES.SM
                      ? 0
                      : 1,
                  backgroundColor: AppColors.grayColor_333333,
                  marginVertical:
                    deviceSize == DEVICE_SIZES.XS ||
                    deviceSize == DEVICE_SIZES.SM
                      ? 0
                      : 10,
                  marginHorizontal:
                    deviceSize == DEVICE_SIZES.XS ||
                    deviceSize == DEVICE_SIZES.SM
                      ? 0
                      : 5,
                  marginRight:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 0
                      : 50,
                }}
              />
            ) : (
              <View
                style={{
                  marginLeft: 56,
                }}
              ></View>
            )}
            <View style={styles.SceneView}>
              {loader ? (
                <GoLiveUpperDropdown />
              ) : (
                <>
                  <View
                    style={[
                      {
                        flexDirection: "row",
                        paddingTop: 5,
                        paddingBottom: 25,
                        columnGap: 10,
                      },
                    ]}
                  >
                    <GoLiveScene />
                    <GoLiveGeneralFeat />
                  </View>
                </>
              )}
              {chatOpen &&
                (loader ? (
                  <GoliveDisplaySkeleton />
                ) : (
                  <View>
                    <GoLiveView chatOpen={chatOpen} />
                    <LiveDetail styles={styles} />

                    <View
                      style={{
                        height: 2,
                        backgroundColor: AppColors.grayColor_333333,
                        marginVertical: 5,
                        marginHorizontal: 5,
                      }}
                    />
                    <View
                      style={[
                        styles.commentsOuterView,
                        {
                          gap: 10,
                          marginTop: 15,
                          flexDirection:
                            deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.MD
                              ? "column"
                              : "row",
                        },
                      ]}
                    >
                      {/* Comments */}
                      {deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM ? null : (
                        <View style={{ width: 347 }}>
                          <Text style={AppFontStyle.REGULAR_ANYBODY_16}>
                            Share Stream
                          </Text>
                          <View style={styles.copyLinkContainer}>
                            <TouchableOpacity onPress={copyToClipboard}>
                              <Image
                                source={AppImages.icLinkSocial}
                                style={styles.linkIcon}
                              />
                            </TouchableOpacity>
                            <Text
                              numberOfLines={4}
                              style={{
                                color: AppColors.white,
                                paddingLeft: 10,
                                flexShrink: 1,
                                overflow: "hidden",
                              }}
                            >
                              {getShareUrl()}
                            </Text>
                          </View>
                          <FlatList
                            data={socialMediaOptions}
                            numColumns={4}
                            renderItem={({ item }) => (
                              <TouchableOpacity
                                style={styles.socialIconContainer}
                                onPress={() => shareOnPlatform(item.name)}
                              >
                                <Image
                                  source={item.image}
                                  style={styles.socialIcon}
                                />
                              </TouchableOpacity>
                            )}
                          />
                        </View>
                      )}

                    </View>
                  </View>
                ))}
            </View>
            {openChat && (
              <GoLiveChatModal
                chatData={chatData}
                isVisible={openChat}
                setChatData={setChatData}
                onClose={() => {
                  setOpenChat(false);
                }}
              />
            )}
            {deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.XS ? (
              loader ? (
                <View>
                  <Skeletons
                    height={400}
                    width={"100%"}
                    style={{
                      borderRadius: 10,
                      marginTop: 10,
                    }}
                  />
                </View>
              ) : (
                <ChatComponent
                  styles={styles}
                  chatOpen={chatOpen}
                  setChatOpen={setChatOpen}
                  chatData={filteredChatData}
                  selectedButton={selectedButton}
                  setSelectedButton={setSelectedButton}
                  renderChatMessages={renderChatMessages}
                  flatListRef={flatListRef}
                  newMessage={newMessage}
                  setNewMessage={setNewMessage}
                  sendComment={sendComment}
                  addNewMessage={addNewMessage}
                  userData={userData}
                  eventId={eventId ?? ""}
                />
              )
            ) : null}
          </View>


        </ScrollView>
      </View>
    </TouchableWithoutFeedback>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: "transparent",
      flex: 1,
    },
    btnTeam: {
      paddingVertical: 15,
      paddingHorizontal: 20,
    },
    innerView: {
      flexDirection: "row",
      columnGap: 35,
      backgroundColor: AppColors.gray_212121,
      paddingHorizontal: 20,
      paddingVertical: 10,
      borderRadius: 10,
    },
    timeContainer: {
      flexDirection: "row",
      columnGap: 15,
      justifyContent: "center",
    },
    btnStartStream: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      borderRadius: 7,
      margin: 10,
    },
    btnBackLive: {
      paddingVertical: 0,
      paddingHorizontal: 70,
      backgroundColor: AppColors.gray_212121,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 10,
      margin: 10,
    },
    btnGoLive: {
      paddingVertical: 0,
      paddingHorizontal: 40,
      shadowOpacity: 0,
      height: 40,
      width: 170,
      borderRadius: 10,
      margin: 10,
    },
    btnSubmitResults: {
      paddingVertical: 0,
      paddingHorizontal: 40,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 10,
      margin: 10,
    },
    senderMainWrapper: {
      flex: 1,
      width: "100%",
      flexDirection: "row",
      marginTop: 8,
      columnGap: 8,
      alignSelf: "flex-start",
    },
    senderChatWrapper: {
      maxWidth: "65%",
      marginEnd: "35%",
      padding: 10,
      borderTopEndRadius: 10,
      borderTopStartRadius: 10,
      borderBottomEndRadius: 10,
      backgroundColor: "#e2e2e2",
      shadowColor: "#ccc",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.25,
      shadowRadius: 2,
      elevation: 1,
    },
    deviceflexDirection: {
      flexDirection: "row",
    },
    OverView: {
      width: "27%",
    },
    SceneView: {
      width: "65%",
    },
    containerDirection: {
      marginVertical: 15,
      marginHorizontal: 50,
      flexDirection: "row",
    },
    LiveView: {
      flexDirection: "row",
      columnGap: 35,
      marginTop: 9,
      justifyContent: "space-between",
    },
    commentsView: {
      borderColor: AppColors.gray_333333,
      marginHorizontal: 5,
      borderWidth: 1,
      borderRadius: 10,
      padding: 10,
      // width:"78%"
    },
    commentsOuterView: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginVertical: 20,
    },
    socialIconContainer: {
      alignItems: "center",
      marginVertical: 5,
    },
    socialIcon: {
      height: 41,
      width: 41,
      resizeMode: "contain",
    },
    socialIconText: {
      color: AppColors.white,
      textAlign: "center",
    },
    // shareText: {
    //   color: AppColors.white,
    //   textAlign: "justify",
    //   lineHeight: 25,
    //   paddingVertical: 20,
    //   fontSize: 16,
    // },
    copyLinkContainer: {
      flexDirection: "row",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      padding: 16,
      borderRadius: 10,
      marginBottom: 10,
      marginTop: 10,
      alignItems: "center",
    },
    linkIcon: {
      height: 20,
      width: 20,
      resizeMode: "contain",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },

      innerView: {
        flexDirection: "row",
        columnGap: 5,
        backgroundColor: AppColors.gray_212121,
        paddingHorizontal: 3,
        paddingVertical: 10,
        borderRadius: 10,
      },

      btnGoLive: {
        alignSelf: "center",
        paddingHorizontal: 30,
        // alignSelf:"flex-end"
      },
      senderMainWrapper: {
        flex: 1,
        width: "100%",
        flexDirection: "row",
        marginTop: 8,
        columnGap: 8,
        alignSelf: "flex-start",
      },
      senderChatWrapper: {
        maxWidth: "65%",
        marginEnd: "35%",
        padding: 10,
        borderTopEndRadius: 10,
        borderTopStartRadius: 10,
        borderBottomEndRadius: 10,
        backgroundColor: "#e2e2e2",
        shadowColor: "#ccc",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 2,
        elevation: 1,
      },
      OverView: {
        width: "98%",
      },
      SceneView: {
        width: "98%",
      },
      containerDirection: {
        marginVertical: 15,
        marginHorizontal: 15,
        flexDirection: "column",
      },
      LiveView: {
        flexDirection: "column",
        gap: 10,
        // columnGap: 5,
        // marginTop: 9,
      },
      commentsView: {
        borderColor: AppColors.gray_333333,
        marginTop: 5,
        marginHorizontal: 5,
        borderWidth: 1,
        borderRadius: 10,
        padding: 10,
        width: "98%",
      },
      commentsOuterView: {
        flexDirection: "column",
        gap: 10,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      btnBackLive: {
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },
      btnBackLive: {
        paddingHorizontal: 30,
      },
      innerView: {
        flexDirection: "row",
        columnGap: 15,
        backgroundColor: AppColors.gray_212121,
        paddingHorizontal: 15,
        paddingVertical: 10,
        borderRadius: 10,
      },

      btnGoLive: {
        marginTop: 20,
        paddingHorizontal: 30,
        // alignSelf:"flex-end"
      },
      senderMainWrapper: {
        flex: 1,
        width: "100%",
        flexDirection: "row",
        marginTop: 8,
        columnGap: 8,
        alignSelf: "flex-start",
      },
      senderChatWrapper: {
        maxWidth: "65%",
        marginEnd: "35%",
        padding: 10,
        borderTopEndRadius: 10,
        borderTopStartRadius: 10,
        borderBottomEndRadius: 10,
        backgroundColor: "#e2e2e2",
        shadowColor: "#ccc",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 2,
        elevation: 1,
      },
      OverView: {
        width: "98%",
      },
      SceneView: {
        width: "100%",
      },
      containerDirection: {
        marginVertical: 15,
        marginHorizontal: 15,
        flexDirection: "column",
      },
      LiveView: {
        flexDirection: "row",
        columnGap: 9,
        marginTop: 9,
      },
      commentsView: {
        borderColor: AppColors.gray_333333,
        marginHorizontal: 5,
        borderWidth: 1,
        marginTop: 10,
        borderRadius: 10,
        padding: 10,
        width: "65%",
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },

      innerView: {
        flexDirection: "row",
        columnGap: 15,
        backgroundColor: AppColors.gray_212121,
        paddingHorizontal: 15,
        paddingVertical: 10,
        borderRadius: 10,
      },

      btnGoLive: {
        marginTop: 20,
        // alignSelf:"flex-end"
      },
      senderMainWrapper: {
        flex: 1,
        width: "100%",
        flexDirection: "row",
        marginTop: 8,
        columnGap: 8,
        alignSelf: "flex-start",
      },
      senderChatWrapper: {
        maxWidth: "65%",
        marginEnd: "35%",
        padding: 10,
        borderTopEndRadius: 10,
        borderTopStartRadius: 10,
        borderBottomEndRadius: 10,
        backgroundColor: "#e2e2e2",
        shadowColor: "#ccc",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 2,
        elevation: 1,
      },
      OverView: {
        width: "98%",
      },

      containerDirection: {
        margin: 15,
        flexDirection: "column",
      },
      LiveView: {
        flexDirection: "row",
        columnGap: 9,
        marginTop: 9,
      },
      commentsView: {
        borderColor: AppColors.gray_333333,
        marginHorizontal: 5,
        borderWidth: 1,
        marginTop: 10,
        borderRadius: 10,
        padding: 10,
        width: "65%",
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },

      innerView: {
        flexDirection: "row",
        columnGap: 15,
        backgroundColor: AppColors.gray_212121,
        paddingHorizontal: 15,
        paddingVertical: 10,
        borderRadius: 10,
      },

      senderMainWrapper: {
        flex: 1,
        width: "100%",
        flexDirection: "row",
        marginTop: 8,
        columnGap: 8,
        alignSelf: "flex-start",
      },
      senderChatWrapper: {
        maxWidth: "65%",
        marginEnd: "35%",
        padding: 10,
        borderTopEndRadius: 10,
        borderTopStartRadius: 10,
        borderBottomEndRadius: 10,
        backgroundColor: "#e2e2e2",
        shadowColor: "#ccc",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 2,
        elevation: 1,
      },
      OverView: {
        width: "35%",
      },

      containerDirection: {
        margin: 15,
        flexDirection: "row",
      },
      LiveView: {
        flexDirection: "row",
        columnGap: 5,
        marginTop: 9,
      },
      commentsView: {
        borderColor: AppColors.gray_333333,
        marginHorizontal: 5,
        borderWidth: 1,
        borderRadius: 10,
        padding: 10,
        width: "58%",
      },
      deviceflexDirection: {
        flexDirection: "row",
      },
    },
  }
);
